//DEPRECATED : This file is deprecated.  See searchListings.js for the client side search query.
//This was used when search was redux based, it is now query parameter based.

// Redux Form
import { SubmissionError } from 'redux-form';

// Redirection
import history from '../../../core/history';

// Fetch request
import fetch from '../../../core/fetch';

// Redux
import {
  getSearchResults,
  loadingSearchResults,
} from '../../../actions/getSearchResults';
import { searchQuery } from '../../../actions/searchListing';
import { query } from '../../../core/createApolloClient/createApolloClient.client';

async function submit(values, dispatch) {
  dispatch(loadingSearchResults());
  console.log('Submitting search', values, dispatch);

  const resp = await query(searchQuery, values);

  const { data } = resp;

  if (data && data.SearchListing) {
    dispatch(getSearchResults(data.SearchListing));
    //dispatch(showResults());
  }
}

export default submit;



// WEBPACK FOOTER //
// ./src/components/SearchListing/SearchForm/submit.js